export default __webpack_public_path__ + "static/media/results-page-blur-small.69a656a5.png";